import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBWrWwubWFMefg6qNDg0vKvHb0usI0TSGE",
  authDomain: "rentduo-5ee1c.firebaseapp.com",
  projectId: "rentduo-5ee1c",
  storageBucket: "rentduo-5ee1c.firebasestorage.app",
  messagingSenderId: "602432228481",
  appId: "1:602432228481:web:b72a098a6c4bc561e59180",
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;